export default {"src":"/_next/static/media/verified-icon.f45b3327.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};